<template>
  <v-row class="fill-height">
    <v-col cols="12" v-if="hosting_error">
      <v-card class="app-card" text>
        <v-card-text>
          <p class="mb-0">{{ hosting_error }}</p>
        </v-card-text>
      </v-card>
    </v-col>
    <template v-else>
      <v-col cols="12" sm="6">
        <v-server-status-info :loading="loading"/>
      </v-col>
      <v-col cols="12" sm="6">
        <v-server-product-info />
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import VServerProductInfo from 'Components/Services/Hosting/Common/ServiceInfo'
import VServerStatusInfo from 'Components/Services/Hosting/VPS/ServiceStatus'

export default {
  name: 'HostingVServerInfo',
  components: {
    VServerProductInfo,
    VServerStatusInfo,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  computed: mapGetters(['hosting_error']),
}
</script>
